import CONFIG from 'core/globals';
import React, { useState, useEffect } from 'react'
import cn from 'classnames';

const VIPBadge = ({ showDescription = false, isVirtualHottie = false }) => {
  const {parentSiteName} = CONFIG;
  const [IconComponent, setIconComponent] = useState(null);

  useEffect(() => {
    if (!parentSiteName) { return; }
    try {
      const icon = require(`../../../assets/vipIcons/vip_icon_${parentSiteName}.svg`);
      setIconComponent(() => icon.default);
    } catch (error) {
      console.error('Icon not found:', parentSiteName);
    }
  }, [parentSiteName]);

  if (!IconComponent) {
    return null;
  }

  return (
    <div className={cn('vip-badge', { 'should-shift-left': !isVirtualHottie })}>
      {IconComponent && <IconComponent/>}
      {showDescription && <span className="vip-badge-description">
        Only accessible to VIP members
      </span>}
    </div>
  )
}

export default VIPBadge;
